import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import { ref, PropType, onMounted } from 'vue';
import Modal from '@/shared/components/Modal.vue';
import ContentHighlightsArticleAppEdit from './ContentHighlightsArticleAppEdit.vue';
import ContentHighlightsListAppEdit from './ContentHighlightsListAppEdit.vue';
import { ArticleAppConfig } from './models/ArticleApp';
import { ListApp, ListAppItem } from './models/ListApp';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentHighlightsEditModal',
  props: {
  appConfig: {
    type: Object as PropType<ConfiguredAppIntegration>,
    required: true,
  },
},
  emits: ["save", "cancel"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isLoading = ref(false);
const isInvalid = ref(false);
const articleAppConfig = ref<ArticleAppConfig>();
const listAppConfig = ref<ListApp>();

const $v = useVuelidate();

onMounted(() => {
  if (isArticleApp()) {
    articleAppConfig.value = {
      image_url: props.appConfig.config.image_url,
      header_text: props.appConfig.config.header_text,
      body_text: props.appConfig.config.body_text,
      article_url: props.appConfig.config.article_url,
      link_label: props.appConfig.config.link_label,
      $templateName: 'SingleHighlight',
    };
  } else {
    parseListAppConfig();
  }
});

function isArticleApp(): boolean {
  return props.appConfig.config.$templateName === 'SingleHighlight';
}

async function saveApp() {
  $v.value.$touch();
  if ($v.value.$invalid) {
    return;
  }
  emit(
    'save',
    isArticleApp()
      ? {
          config: {
            ...articleAppConfig.value,
          },
          installedAppId: props.appConfig.installedAppId,
        }
      : getListAppFromConfig(),
  );
}

function handleInvalid(value: boolean) {
  isInvalid.value = value;
}

function parseListAppConfig() {
  const items: ListAppItem[] = [
    {
      url: '',
      description: '',
      label: '',
      image: '',
    },
  ];

  for (const [key, value] of Object.entries(props.appConfig.config).filter(([k]) => k.includes('url'))) {
    const parts = key.split('_');
    if (!items[Number(parts[parts.length - 1]) - 1]) {
      items[Number(parts[parts.length - 1]) - 1] = {
        url: '',
        description: '',
        label: '',
        image: '',
      };
    }
    items[Number(parts[parts.length - 1]) - 1][parts[parts.length - 2] as keyof ListAppItem] = value as string;
  }

  listAppConfig.value = {
    heading: props.appConfig.config.header,
    $templateName: 'ListOfHighlights',
    items,
  };
}

function getListAppFromConfig(): ConfiguredAppIntegration {
  const connectListApp: ConfiguredAppIntegration = {
    installedAppId: props.appConfig.installedAppId,
    config: {
      header: listAppConfig.value?.heading,
      $templateName: 'ListOfHighlights',
    },
  };

  if (!listAppConfig.value?.items) {
    throw new Error("App doesn't contain any items");
  }

  for (let i = 0; i < listAppConfig.value.items.length; i += 1) {
    connectListApp.config[`url_${i + 1}`] = listAppConfig.value.items[i].url;
    connectListApp.config[`url_description_${i + 1}`] = listAppConfig.value.items[i].description;
    connectListApp.config[`url_label_${i + 1}`] = listAppConfig.value.items[i].label;
    connectListApp.config[`url_image_${i + 1}`] = listAppConfig.value.items[i].image;
  }

  return connectListApp;
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, {
    onCancel: _cache[3] || (_cache[3] = ($event: any) => (emit('cancel')))
  }, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "media" }, [
        _createElementVNode("div", { class: "media-left" }, [
          _createElementVNode("figure", { class: "image is-48x48" }, [
            _createElementVNode("svg", { class: "app-icon" }, [
              _createElementVNode("use", {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": "#contenthighlights"
              })
            ])
          ])
        ]),
        _createElementVNode("div", { class: "media-content" }, [
          _createElementVNode("p", { class: "title is-4" }, [
            _createElementVNode("strong", null, "Content Highlights")
          ]),
          _createElementVNode("p", { class: "subtitle is-6" }, "Highlight important content to customers within your Web Assistant")
        ])
      ], -1)
    ])),
    body: _withCtx(() => [
      (isArticleApp() && articleAppConfig.value)
        ? (_openBlock(), _createBlock(ContentHighlightsArticleAppEdit, {
            key: 0,
            modelValue: articleAppConfig.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((articleAppConfig).value = $event)),
            onIsInvalid: handleInvalid
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!isArticleApp() && listAppConfig.value)
        ? (_openBlock(), _createBlock(ContentHighlightsListAppEdit, {
            key: 1,
            modelValue: listAppConfig.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listAppConfig).value = $event)),
            value: listAppConfig.value,
            onIsInvalid: handleInvalid
          }, null, 8, ["modelValue", "value"]))
        : _createCommentVNode("", true)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            loading: isLoading.value,
            disabled: isInvalid.value,
            onClick: saveApp
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Update")
            ])),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_n_button, {
            variant: "primary--outline",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})